const { IMANAGE_LINK } = (window === null || window === void 0 ? void 0 : window._env_) || {};
export const imanageLink = IMANAGE_LINK || process.env.IMANAGE_LINK;
const imanageLinkRegex = RegExp(`^${imanageLink}(?=.+[a-zA-Z0-9]+![0-9]+(:?.[0-9]+))`);
export const imanageInvalidLinkErrorMessage = `iManage link has to start with '${imanageLink}' and contain library name and document id`;
export const imanageLinkValidator = (link) => {
    const canSave = imanageLinkRegex.test(link);
    if (!canSave && !!link) {
        return imanageInvalidLinkErrorMessage;
    }
    return true;
};
